import React, { useState } from "react";
import { Button, Colors, Display, Sizes } from "Views/Components/Button/Button";
import { ESignEnevlopeList } from "./ESignEnevlopeList";
import { ESignEnvelopeCreateProvider, ESignEnvelopeCreateWorkflow } from "./ESignEnvelopeCreate";

type Props = {
	businessEntityId: string;
	businesEntityName: string;
}

export const ESignEnvelopeTab: React.FunctionComponent<Props> = ({ businessEntityId, businesEntityName }) => {
	const [showCreateEnvelope, setShowCreateEnvelope] = useState(false);
	const [updateList, setUpdateList] = useState(false);

	return (
		<div className="esign-envelopes">
			<div className="actions">
				<Button
					colors={Colors.Primary}
					sizes={Sizes.Medium}
					display={Display.Solid}
					onClick={() => setShowCreateEnvelope(true)}
					disabled={showCreateEnvelope}
				>
					Create New Workflow
				</Button>
			</div>
			<ESignEnevlopeList
				businessEntityId={businessEntityId}
				refresh={updateList}
				reset={() => setUpdateList(false)}
			/>
			{showCreateEnvelope && (
				<>
					<ESignEnvelopeCreateProvider businessEntityId={businessEntityId} businessEntityName={businesEntityName}>
						<ESignEnvelopeCreateWorkflow
							onClose={() => { setShowCreateEnvelope(false); setUpdateList(true); }}
						/>
					</ESignEnvelopeCreateProvider>
				</>)}
		</div>
	)
}